<template>
  <div class="ActivityReviews">
    <div class="m-t-2 row">
      <div class="col-md-12">
        <h2>{{t('Reviews')}}</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-lg-6 col-xl-4  m-t-2 reviewContainer" v-for="review in reviews()">
        <div class="card">
          <div class="card-block">
            <!--Title-->
            <div  class="review m-b-3 sameHeight">
              <p><span class="h4">{{review.name}}</span> <span class="stars"><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star"></i><i class="fa fa-star-o"></i></span><br/>
              <span class="timeAgo">({{review.timeAgo}})</span>
              </p>
              <p>{{review.text}}</p>
            </div>
            <!--Text-->

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MatchHeight from 'jquery-match-height'; // eslint-disable-line

const $ = window.$;

export default {
  name: 'ActivityReviews',
  data() {
    return {
      reviews() {
        const reviews = [];
        const count = 10;
        for (let i = 0; i < count; i += 1) {
          reviews.push({
            // name: `${faker.name.firstName()} ${faker.name.lastName()}`,
            timeAgo: '1 week ago',
            stars: 4,
            avatar: '',
            // text: faker.lorem.paragraph(),
          });
        }
        return reviews;
      },
    };
  },
  mounted() {
    $('.sameHeight').matchHeight();
  },
};
</script>

<style lang="scss" scoped>
.reviewRow {

}
.reviewContainer {
  display: inline-block;
  float: none;
  vertical-align: top;
}
.stars {
  color: #FFBB33;
  display: inline-block;
  padding-left: 1em;
  letter-spacing: 3px;
}
</style>



// WEBPACK FOOTER //
// ActivityReviews.vue?0d5b0afc